import styled from "styled-components";
import { mb } from "styled-components-spacing";
import { PrimaryButton } from "@nib-components/button";
export const NoSpacingPrimaryButton = styled(PrimaryButton)`
  ${mb(0)}
`;
